import type { FaireProductEntity } from "../../entity_types/product";

export const p_675q86g4gc: FaireProductEntity = {
  token: "p_675q86g4gc",
  type: "product",
  name: "12\" x 12\" x 6\" Shipping Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/c53cf1bd0ba7d1386d3aa1e7169a79b36a0247907a178f2f488501b1d5171012.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/920347605883b83a92103b580a2758c62b387adf8e60095cc86d992e7e61f311.jpeg",
    "https://cdn.faire.com/fastly/6aefb05411542535d34ec485ddf60b0f450aae6a41465d896a071e0472671184.jpeg",
    "https://cdn.faire.com/fastly/cfc784cadba72fcffe29fabd15e8d9ee4683dbb683a432aba94552225033eb0a.jpeg"
  ],
  priceDollars: 28,
  description: "Sturdy 12\" x 12\" x 6\" corrugated shipping boxes that fit a wide variety of retail products and supplies, for packing, storage and shipping.\n\n- Size: 12\" x 12\" x 6\"\n- Material: corrugated\n- Ships and stores flat; assemble and seal when needed\n- Quantity: 25 boxes per bundle\n\nA dependable everyday box for boutiques, online sellers, backrooms and shipping areas.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:06.779Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
